import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row } from 'react-bootstrap';
import * as actions from 'containers/Groups/actions';
import * as createGroupModalActions from 'containers/PageHeader/Groups/store/actions';
import GroupsPageHeader from 'components/Groups/PageHeader';
import GroupsTablesWidget from 'containers/Groups/TablesWidget';
import ViewGroupModal from './View';
import CreateEditGroupModal from 'containers/PageHeader/Groups/CreateEdit';
import DeleteConfirmationModal from './Delete';
import { CONTEXT_ITEM_GROUP, CONTEXT_STORE_GROUP, STORES_GROUPS_TYPE } from 'utils/types';
import { FetchFilterGroupsDocument as fetchGroupsQuery } from 'generated/favorites-graphql';
import { favGroupsClient } from 'apollo';
import {
  clientIdSelector,
  currentBrandSelector,
  isEnterpriseContextSelector,
} from 'store/global/selectors';

import {
  useTableQueryState,
  useTableQuery,
  QueryResult,
  QueryStateResult,
} from '@spins/react-table';

import { ROUTES } from 'utils/routes';
import ReactGA from 'react-ga';
import './styles.scss';

interface Props {
  clientId: string;
  onTabSelect(tab: string): void;
  onCreateGroupClick: any;
  currentBrand: string;
  enterpriseBrand: string;
  isEnterpriseContext: boolean;
}

const Groups: React.FC<Props> = ({
  clientId,
  currentBrand,
  isEnterpriseContext,
  onTabSelect,
  onCreateGroupClick,
}) => {
  useEffect(() => {
    ReactGA.pageview(ROUTES.GROUPS);
    onTabSelect(STORES_GROUPS_TYPE);
  });

  // tables state
  const tablesState: QueryStateResult = useTableQueryState([
    {
      id: 'stores',
      queryVariables: {
        clientID: clientId,
        context: CONTEXT_STORE_GROUP,
        ...(isEnterpriseContext && { brand: currentBrand }),
      },
    },
    {
      id: 'items',
      queryVariables: {
        clientID: clientId,
        context: CONTEXT_ITEM_GROUP,
        ...(isEnterpriseContext && { brand: currentBrand }),
      },
    },
  ]);

  // stores query
  const {
    data: storesData,
    loading: storesLoading,
    error: storesError,
    refetch: storesRefecth,
  }: QueryResult = useTableQuery(fetchGroupsQuery, {
    client: favGroupsClient,
    queryState: tablesState.queryState('stores'),
  });

  // items query
  const {
    data: itemsData,
    loading: itemsLoading,
    error: itemsError,
    refetch: itemsRefecth,
  }: QueryResult = useTableQuery(fetchGroupsQuery, {
    client: favGroupsClient,
    queryState: tablesState.queryState('items'),
  });

  return (
    <div className="groups">
      <Row>
        <GroupsPageHeader>
          <div className="header-buttons-container">
            <Button className="btn-create-group" onClick={onCreateGroupClick}>
              CREATE GROUP
            </Button>
          </div>
        </GroupsPageHeader>
      </Row>
      <Row className="mt-3">
        <Col>
          <GroupsTablesWidget
            storesData={storesData}
            storesLoading={storesLoading}
            storesError={storesError}
            itemsData={itemsData}
            itemsLoading={itemsLoading}
            itemsError={itemsError}
          />
        </Col>
      </Row>
      <CreateEditGroupModal storesRefecth={storesRefecth} itemsRefecth={itemsRefecth} />
      <ViewGroupModal />
      <DeleteConfirmationModal />
    </div>
  );
};

const mapStateToProps = (state) => ({
  clientId: clientIdSelector(state),
  currentBrand: currentBrandSelector(state),
  isEnterpriseContext: isEnterpriseContextSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  onCreateGroupClick: () => {
    dispatch(createGroupModalActions.open());
  },
  onTabSelect: (value: string) => {
    dispatch(actions.selectTab(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Groups);
